import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import img from "./images/people.svg";
import { Modal } from "react-bootstrap";
import spinnerimg from "./images/Inaipi_Logo-1.2.png";
import "./Dashboard2.css";
import Badge from "@mui/material/Badge";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import ForumIcon from "@mui/icons-material/Forum";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import OutboundIcon from "@mui/icons-material/Outbound";
import GroupIcon from "@mui/icons-material/Group";
import moment from "moment";
import {

  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure
} from "../../container/BaseUrl/BaseUrl";
import axios from "axios";
import {
  setchatdata,
  setchatid,
  setChatRefresh,
  endInteraction,
  setsidebarVal,
  setShowingStatus,
} from "../../redux/actions/actions";
import { Slide, Typography, Box, Pagination, Stack } from "@mui/material";

// component import
import { errorhandelApi } from "../../ApiCall/ErrorHandelApi";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Eye, FrameCorners } from "@phosphor-icons/react";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

const api = {
  key: "d5636778a0512845243f75043eb65a3d",
  base: "https://api.openweathermap.org/data/2.5/",
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    agentStatusrefreash: state.data.agentStatusrefreash,
  };
};

const Dashboard = (props) => {
  const navigate = useNavigate();
  const AvcUrl = localStorage.getItem("AvcUrl");
  const LoggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const userName = JSON.parse(localStorage.getItem("tokenAgent"));
  const [dashboardcount, setDashboardcount] = useState([]);
  const [teamactivitydashboardcount, setTeamactivitydashboardcount] = useState(
    []
  );
  const [dashboardcountagent, setDashboardcountagent] = useState([]);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [spinner, setspinner] = useState(false);
  const [weather, setWeather] = useState();
  const [OngoingInteractionList, setOngoingInteractionList] = useState([]);
  const [OngoingInteraction, setOngoingInteraction] = useState(false);
  const [Interactionpage, setInteractionpage] = useState(1);
  const [Interactionpagepagination, setInteractionpagePagination] = useState(0);

  const convertSecondsToTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toFixed(2).toString().padStart(5, "0")}`;
  };

  const SupervisorObserver = async (el) => {
    localStorage.removeItem("client");
    try {
      const access_token = localStorage.getItem("access_token");
      let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));

      if (
        el.channel == "webchat" ||
        el.channel == "from_whatsapp" ||
        el.channel == "from_facebook" ||
        el.channel == "from_purple"
      ) {
        let dataToPass = {
          sessionId: el.chat_session_id,
          agentId: old_agent_id.agent_id,
          oldAgentId: el.agent,
        };

        const data = await axios.post(
          BaseUrl + "/users/conferenceAgent",
          dataToPass,
          {
            headers: {
              Authorization: "Bearer " + access_token,
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        );

        if (data.data.status == true) {
          navigate("/main/Chat");
          props.setsidebarVal("Chat");
          localStorage.setItem("indexOf", 2);
          toast.success("Conferenced to supervisor success", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.warn(data.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      } else if (el.channel == "voice") {
        try {
          let ssToken = localStorage.getItem("ssoToken");
          await axios
            .post(
              AvcUrl +
                `/voice/terminal/${localStorage.getItem(
                  "agentLoginTerminalId"
                )}/observe/sip:${localStorage.getItem(
                  "agentLoginTerminalId"
                )}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}/${el.voice_contactId}`,
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then((res) => {
              if (res.data.statusCode == 200) {
                localStorage.setItem("showBarginButton", "true");
              } else {
                toast.warn(res.data.message, {
                  position: "top-right",
                  autoClose: 500,
                  hideProgressBar: true,
                  closeOnClick: false,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((err) => {});
        } catch (error) {
          console.log("voice", error);
        }
      }
    } catch (error) {
      console.log("SupervisorObserver", error);
    }
  };

  const searchWeather = async () => {
    await axios
      .get(`${api.base}weather?q=${"Bangalore"}&units=metric&APPID=${api.key}`)

      .then((res) => {
        setWeather(res.data);
      });
  };

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const agentId = JSON.parse(localStorage.getItem("tokenAgent"));

  //  CURRENT TIME FUNCTION
  var time = new Date().toLocaleTimeString();
  const [ctime, setCtime] = useState(time);
  const updateTime = () => {
    var time = new Date().toLocaleTimeString();
    setCtime(time);
  };
  setInterval(updateTime, 1000);
  var m_names = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var d = new Date();
  var month = m_names[d.getMonth()];

  const SupervisorTeamActivityList = async () => {
    console.log("hiiii");
    await axios
      .post(
        BaseUrl + "/dashboard/chatCount",
        {
          from_date: defaultValue,
          to_date: defaultValue,
          offset: page == 1 ? 0 : (page - 1) * 5,
          limit: 5,
          agent_id: agentId.agent_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setTeamactivitydashboardcount(res.data.Data);
          setPagination(res.data.count);
          setspinner(false);
        } else {
          setTeamactivitydashboardcount([]);
          setPagination(0);
          setspinner(false);
        }
      })
      .catch((err) => {
        console.log("SupervisorTeamActivityList", err);
        setspinner(false);
      });
  };

  //Agent
  const AgentDashBoard = async () => {
    const agentId = JSON.parse(localStorage.getItem("tokenAgent"));
    try {
      await axios
        .post(
          BaseUrl + "/dashboard/taskCountByAgentId",
          {
            agent_id: agentId.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status) {
            setDashboardcountagent(res.data);
            setspinner(false);
          } else {
            setDashboardcountagent([]);
            setspinner(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setspinner(false);
        });
    } catch (error) {
      errorhandelApi(error, "/dashboard/taskCountByAgentId");
      setTimeout(() => {
        setspinner(false);
      }, 2000);
    }
  };
  //Supervisor
  const SupervisorDashBoard = async () => {
    await axios
      .post(
        BaseUrl + "/dashboard/dashboardCount",
        { agent_id: agentId.agent_id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setDashboardcount(res.data);
          setspinner(false);
        } else {
          setDashboardcount([]);
          setspinner(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setspinner(false);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  var seconds = dashboardcountagent.TotalBreakTime;
  var duration = moment.duration(seconds, "seconds");
  var dashboardcountagentTotalBreakTime = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");
  var seconds = dashboardcountagent.TotalActiveTime;
  var duration = moment.duration(seconds, "seconds");
  var dashboardcountagentTotalActiveTime = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");

  const openOngoingInteractionApi = (agentID) => {
    let body = {
      agentId: agentID,
      offset: Interactionpage == 1 ? 0 : (Interactionpage - 1) * 5,
      limit: 5,
    };
    axios
      .post(BaseUrl + "/users/agentActiveChat", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          setOngoingInteractionList(res.data.data);
          setInteractionpagePagination(res.count);
        } else {
          setOngoingInteractionList([]);
          setInteractionpagePagination(0);
        }
      })

      .catch((error) => {
        setOngoingInteractionList([]);
        setInteractionpagePagination(0);
      });
  };

  const openOngoingInteractionDialogBox = (value) => {
    setOngoingInteraction(true);
  };
  const OngoingInteractionDialogBoxclose = () => {
    setOngoingInteraction(false);
  };

  const InteractionhandleChange = (event, value) => {
    setInteractionpage(value);
  };

  useEffect(() => {
    if (LoggedInAgent.role == "Agent") {
      AgentDashBoard();
    } else {
      SupervisorDashBoard();
    }
  }, []);

  useEffect(() => {
    if (LoggedInAgent.role == "Supervisor") {
      SupervisorTeamActivityList();
    }
  }, [page]);

  const handleRotate = () => {
    if (LoggedInAgent.role == "Agent") {
      AgentDashBoard();
      setspinner(true);
    } else {
      SupervisorDashBoard();
      SupervisorTeamActivityList();
      setspinner(true);
    }
  };

  const handleRotate2 = () => {
    if (LoggedInAgent.role == "Agent") {
      AgentDashBoard();
    } else {
      SupervisorDashBoard();
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleRotate2();
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <div className="container2">
        {LoggedInAgent.role == "Supervisor" ? (
          <>
            <div className="main-panel" style={{ height: "100vh" }}>
              <div
                className="content-wrapper"
                style={{ overflowY: "scroll", height: "100vh" }}
              >
                <div className="row">
                  <div className="col-md-12 grid-margin">
                    <div className="row">
                      <div className="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h4 className="font-weight-bold text-truncate">
                          Welcome
                          <span className="text-primary mx-1">
                            {userName.username ? userName.username : ""}
                          </span>
                        </h4>
                        <h6
                          className="font-weight-normal mb-0"
                          style={{ fontSize: "12px" }}
                        >
                          Last Logged Out :
                          {moment(LoggedInAgent.updatedAt).format("L")}
                          <span className="text-primary mx-1">
                            {moment(LoggedInAgent.updatedAt).format(
                              "hh:mm:ss A"
                            )}
                          </span>
                        </h6>
                      </div>

                      <div className="col-12 col-xl-4">
                        <div className="justify-content-end d-flex">
                          <div className="">
                            <button
                              className="btn btn-sm btn-light bg-white"
                              type="button"
                              id="dropdownMenuDate2"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="true"
                              style={{ fontSize: "12px" }}
                            >
                              <i className="mdi mdi-calendar"></i> Today (
                              {defaultValue}) : {ctime}
                            </button>
                            <button
                              className="btn btn-sm btn-light bg-white mx-2"
                              id="refresh-chat"
                              type="button"
                              onClick={() => {
                                handleRotate();
                              }}
                              style={{ fontSize: "12px" }}
                            >
                              Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 grid-margin transparent">
                    <div className="row">
                      <div
                        className="col-md-3 mb-4 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-tale">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Agents - LoggedIn
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                              {dashboardcount.AgentLoggedIn == null ||
                              dashboardcount.AgentLoggedIn == undefined
                                ? 0
                                : dashboardcount.AgentLoggedIn}
                            </p>
                            <p className="className="></p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 mb-4 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-dark-blue">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Agents - Active
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                              {dashboardcount.AgentActive == null ||
                              dashboardcount.AgentActive == undefined
                                ? 0
                                : dashboardcount.AgentActive}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 mb-4 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-dark-blue2">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Agents - Offline
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>
                              {dashboardcount.AgentOffline == null ||
                              dashboardcount.AgentOffline == null
                                ? 0
                                : dashboardcount.AgentOffline}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 mb-4 mb-lg-0 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-light-blue">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Agents Not Ready
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                              {dashboardcount.AgentNotReady == null ||
                              dashboardcount.AgentNotReady == undefined
                                ? 0
                                : dashboardcount.AgentNotReady}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-light-danger2">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Agent Abandoned
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>

                              {dashboardcount.abadoned_count == null ||
                              dashboardcount.abadoned_count == null
                                ? 0
                                : dashboardcount.abadoned_count}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 mb-4 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-light-danger2">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              SLA - Digital
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>

                              {dashboardcount.slacount == null ||
                              dashboardcount.slacount === 0
                                ? "0%"
                                : dashboardcount.slacount + "%"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 mb-4 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-dark-blue2">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Longest Wait - Digital
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>
                              {convertSecondsToTime(dashboardcount.longwait)}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-3 stretch-card transparent"
                        style={{ height: "70px" }}
                      >
                        <div className="card card-light-danger">
                          <div className="card-body">
                            <p className="mb-1 text-white dashboard-heading-fonts">
                              Queued Count - Digital
                            </p>
                            <p
                              className="fs-30 mb-2 text-white"
                              style={{ fontSize: "17px" }}
                            >
                              <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                              {dashboardcount.QueuedChat == null ||
                              dashboardcount.QueuedChat == undefined
                                ? 0
                                : dashboardcount.QueuedChat}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card" style={{ height: "400px" }}>
                      <div className="card-body">
                        <Stack direction={"row"} sx={{ display: "flex" }}>
                          <Typography>Team Activity</Typography>
                          <Box
                            sx={{
                              width: "35px",
                              height: "35px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "50%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open("/Agent-List", "_blank");
                            }}
                          >
                            <AspectRatioIcon />
                          </Box>
                        </Stack>

                        <div className="row mt-2">
                          <div className="col-12">
                            <div
                              className="table_scroll"
                              style={{
                                position: "relative",
                                overflowY: "hidden",
                              }}
                            >
                              <div
                                className="table-responsive fffff"
                                style={{
                                  overflowY: "auto",
                                  maxHeight: "300px",
                                  paddingRight: "",
                                  marginRight: "",
                                }}
                              >
                                <table
                                  id="example"
                                  className="display expandable-table"
                                >
                                  <thead
                                    style={{
                                      background: "#fff",
                                      zIndex: 2,
                                      position: "sticky",
                                      top: 0,
                                    }}
                                  >
                                    <tr>
                                      <th className="dashboard-heading-table">
                                        Agent Name
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Status
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Ongoing Interaction
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Total Interaction
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Total In/Out
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Missed Interaction
                                      </th>
                                      <th className="text-center dashboard-heading-table">
                                        Transferred
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    className="scroll_tbody fffff"
                                    style={{
                                      maxHeight: "340px",
                                      overflowY: "scroll",
                                    }}
                                  >
                                    {teamactivitydashboardcount.length > 0 ? (
                                      teamactivitydashboardcount.map(
                                        (item, index) => (
                                          <tr key={index}>
                                            <td
                                              className=""
                                              style={{
                                                fontSize: "13px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              {item.agent_id == null ||
                                              item.agent_id == undefined ||
                                              item.agent_id == ""
                                                ? "--"
                                                : item.agent_id.username}
                                            </td>

                                            <td className="text-center">
                                              {item.agent_id == null ||
                                              item.agent_id == undefined ||
                                              item.agent_id == "" ? (
                                                "--"
                                              ) : item.agent_id
                                                  .agent_status_real ==
                                                  "Available" ||
                                                item.agent_id
                                                  .agent_status_real ==
                                                  "Ready" ? (
                                                <Badge
                                                  color="success"
                                                  badgeContent={
                                                    item.agent_id
                                                      .agent_status_real
                                                  }
                                                  // style={{width:100}}
                                                ></Badge>
                                              ) : item.agent_id
                                                  .agent_status_real ==
                                                "Connected" ? (
                                                <Badge
                                                  color="info"
                                                  badgeContent={
                                                    item.agent_id
                                                      .agent_status_real
                                                  }
                                                ></Badge>
                                              ) : (
                                                <Badge
                                                  color="warning"
                                                  badgeContent={
                                                    item.agent_id
                                                      .agent_status_real
                                                  }
                                                  style={{
                                                    width: 100,
                                                    marginRight: "100px",
                                                  }}
                                                  sx={{ zIndex: "0" }}
                                                ></Badge>
                                              )}
                                            </td>

                                            <td
                                              className="text-center"
                                              id="interaction-chat"
                                            >
                                              <Badge
                                                badgeContent={item.total_active}
                                                color="warning"
                                                sx={{ zIndex: "0" }}
                                              >
                                                <QuickreplyIcon
                                                  color="primary"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    openOngoingInteractionDialogBox();
                                                    openOngoingInteractionApi(
                                                      item.agent_id.id
                                                    );
                                                  }}
                                                />
                                              </Badge>
                                            </td>

                                            <td className="text-center">
                                              <Badge
                                                badgeContent={
                                                  item.presented_count
                                                }
                                                color="warning"
                                                sx={{ zIndex: "0" }}
                                              >
                                                <ForumIcon color="primary" />
                                              </Badge>
                                            </td>
                                            <td className="text-center">
                                              <Badge
                                                badgeContent={
                                                  item.answered_count
                                                }
                                                color="warning"
                                                sx={{ zIndex: "0" }}
                                              >
                                                <PermPhoneMsgIcon color="primary" />
                                              </Badge>
                                            </td>
                                            <td className="text-center">
                                              <Badge
                                                badgeContent={
                                                  item.abadoned_count
                                                }
                                                color="warning"
                                                sx={{ zIndex: "0" }}
                                              >
                                                <OutboundIcon color="primary" />
                                              </Badge>
                                            </td>
                                            <td className="text-center">
                                              <Badge
                                                badgeContent={
                                                  item.total_transferred_out
                                                }
                                                color="warning"
                                                sx={{ zIndex: "0" }}
                                              >
                                                <SyncAltIcon color="primary" />
                                              </Badge>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <Stack>No Agent Found</Stack>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 mb-3">
                        <Pagination
                          count={Math.ceil(pagination / 5)}
                          page={page}
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              show={OngoingInteraction}
              size="md"
              onHide={OngoingInteractionDialogBoxclose}
            >
              <Modal.Header
                style={{ backgroundColor: "#0b3363", color: "#fff" }}
              >
                <Modal.Title
                  style={{
                    fontSize: 15,
                    margin: "6px 0 0 0",
                    textTransform: "capitalize",
                  }}
                >
                  Ongoing Interaction
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <>
                  <table className="table table-sm table-hover align-middle">
                    <thead>
                      <tr>
                        <th scope="col" className="text-center">
                          Customer Name
                        </th>
                        <th scope="col" className="text-center">
                          Arival Time
                        </th>
                        <th scope="col" className="text-center">
                          Channel
                        </th>
                        <th scope="col" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(OngoingInteractionList) ? (
                        OngoingInteractionList.map((item) => {
                          return (
                            <tr key={item.unique_id.id}>
                              <td className="text-center">
                                {item.unique_id.username == ""
                                  ? item.unique_id.phonenumber
                                  : item.unique_id.username}
                              </td>
                              <td className="text-center">{item.arrival_at}</td>
                              <td className="text-center">
                                {item.channel == "webchat" ? (
                                  <i className="fa-brands fa-rocketchat text-primary"></i>
                                ) : item.channel == "from_whatsapp" ? (
                                  <i className="fa-brands fa-whatsapp text-primary"></i>
                                ) : item.channel == "from_facebook" ? (
                                  <i className="fa-brands fa-facebook-f text-primary"></i>
                                ) : item.channel == "from_twitter" ? (
                                  <i className="fa-brands fa-twitter text-primary"></i>
                                ) : item.channel == "from_teams" ? (
                                  <i className="fa-brands fa-teams text-primary"></i>
                                ) : item.channel == "videochat" ? (
                                  <i className="fa-solid fa-video text-primary"></i>
                                ) : item.channel == "voice" ? (
                                  <i className="fa-solid fa-phone text-primary"></i>
                                ) : item.channel == "from_purple" ? (
                                  <i className="fa-solid fa-robot"></i>
                                ) : (
                                  <i className="fa-solid fa-envelope text-primary"></i>
                                )}
                              </td>
                              <td className="text-center">
                                <div
                                  className="d-flex"
                                  style={{ justifyContent: "space-evenly" }}
                                >
                                  <Tooltip
                                    title={"Observer"}
                                    arrow
                                    placement="top"
                                  >
                                    <button
                                      type="button"
                                      id="agent-transfer"
                                      className="btn btn-primary btn-sm"
                                      onClick={() => {
                                        SupervisorObserver(item);
                                      }}
                                      disabled={
                                        item.channel == "email" ||
                                        (item.channel == "voice" &&
                                          item.transferred == true)
                                      }
                                    >
                                      <Eye size={22} weight="bold" />
                                    </button>
                                  </Tooltip>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                  <div>
                    <div className="mt-2 mb-3">
                      <Pagination
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={InteractionhandleChange}
                      />
                    </div>
                  </div>
                </>
              </Modal.Body>
              <Modal.Footer style={{ borderTop: "0px" }}></Modal.Footer>
            </Modal>
          </>
        ) : (
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin">
                  <div className="row">
                    <div className="col-12 col-xl-8 mb-4 mb-xl-0">
                      <h4 className="font-weight-bold text-truncate">
                        Welcome
                        <span className="text-primary mx-1">
                          {userName.username ? userName.username : ""}
                        </span>
                      </h4>
                      <h6
                        className="font-weight-normal mb-0"
                        style={{ fontSize: "12px" }}
                      >
                        Last Logged Out :
                        {moment(LoggedInAgent.updatedAt).format("L")}
                        <span className="text-primary mx-1">
                          {moment(LoggedInAgent.updatedAt).format("hh:mm:ss A")}
                        </span>
                      </h6>
                    </div>

                    <div className="col-12 col-xl-4">
                      <div className="justify-content-end d-flex">
                        <div className="">
                          <button
                            className="btn btn-sm btn-light bg-white"
                            style={{ fontSize: "12px" }}
                          >
                            <i className="mdi mdi-calendar"></i> Today (
                            {defaultValue}) : {ctime}
                          </button>
                        </div>

                        <div className="mx-2">
                          <button
                            className="btn btn-sm btn-light bg-white"
                            id="refresh-refresh"
                            style={{ fontSize: "12px" }}
                            type="button"
                            onClick={() => {
                              handleRotate();
                            }}
                          >
                            Refresh
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-5 grid-margin stretch-card">
                  <div className="card tale-bg">
                    <div className="card-people">
                      <img
                        src={img}
                        alt="people"
                        style={{ height: "200px", width: "100%" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-7 grid-margin transparent">
                  <div className="row">
                    <div className="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
                      <div className="card card-light-blue">
                        <div className="card-body">
                          <p className="mb-3 text-white dashboard-heading-fonts">
                            Total Active Time
                          </p>
                          <p
                            className="fs-30 mb-2 text-white"
                            style={{ fontSize: "18px" }}
                          >
                            <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                            {dashboardcountagentTotalActiveTime}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
                      <div className="card card-dark-blue">
                        <div className="card-body">
                          <p className="mb-3 text-white dashboard-heading-fonts">
                            Total Break Time
                          </p>
                          <p
                            className="fs-30 mb-2 text-white"
                            style={{ fontSize: "18px" }}
                          >
                            <i className="fa-solid fa-arrow-turn-up"></i>{" "}
                            {dashboardcountagentTotalBreakTime}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row"></div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card" style={{ height: "200px" }}>
                    <div className="card-body">
                      <p className="card-title">My Activity</p>
                      <div className="row">
                        <div className="col-12">
                          <div className="table-responsive">
                            <table
                              id="example"
                              className="display expandable-table"
                              style={{ width: "100%" }}
                            >
                              <thead>
                                <tr>
                                  <th className="dashboard-heading-table">
                                    Agent Name
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Status
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Ongoing Interaction
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Total Interaction
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Total In/Out
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Missed Interaction
                                  </th>
                                  <th className="text-center dashboard-heading-table">
                                    Transferred
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td
                                    className=""
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {dashboardcountagent.user == null ||
                                    dashboardcountagent.user == undefined ||
                                    dashboardcountagent.user == ""
                                      ? "--"
                                      : dashboardcountagent.user.username}
                                  </td>

                                  <td className="text-center">
                                    {dashboardcountagent.user == null ||
                                    dashboardcountagent.user == undefined ||
                                    dashboardcountagent.user == "" ? (
                                      "--"
                                    ) : dashboardcountagent.user
                                        .agent_status_real ==
                                      "Not Available" ? (
                                      <Badge
                                        color="success"
                                        sx={{ zIndex: "0" }}
                                        badgeContent={
                                          dashboardcountagent.user
                                            .agent_status_real
                                        }
                                      ></Badge>
                                    ) : dashboardcountagent.user
                                        .agent_status_real == "Ready" ||
                                      dashboardcountagent.user
                                        .agent_status_real == "Available" ? (
                                      <Badge
                                        color="success"
                                        sx={{ zIndex: "0" }}
                                        badgeContent={
                                          dashboardcountagent.user
                                            .agent_status_real
                                        }
                                      ></Badge>
                                    ) : dashboardcountagent.user
                                        .agent_status_real == "Connected" ? (
                                      <Badge
                                        color="info"
                                        sx={{ zIndex: "0" }}
                                        badgeContent={
                                          dashboardcountagent.user
                                            .agent_status_real
                                        }
                                      ></Badge>
                                    ) : (
                                      <Badge
                                        sx={{ zIndex: "0" }}
                                        color="warning"
                                        badgeContent={
                                          dashboardcountagent.user
                                            .agent_status_real
                                        }
                                      ></Badge>
                                    )}
                                  </td>

                                  <td className="text-center">
                                    <Badge
                                      badgeContent={
                                        dashboardcountagent
                                          ? dashboardcountagent.totalongoingcount
                                          : null
                                      }
                                      color="warning"
                                      sx={{ zIndex: "0" }}
                                    >
                                      <GroupIcon color="primary" />
                                    </Badge>
                                  </td>

                                  <td className="text-center">
                                    <Badge
                                      badgeContent={
                                        dashboardcountagent
                                          ? dashboardcountagent.presentedcount
                                          : null
                                      }
                                      color="warning"
                                      sx={{ zIndex: "0" }}
                                    >
                                      <ForumIcon color="primary" />
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      badgeContent={
                                        dashboardcountagent.answered_count
                                      }
                                      color="warning"
                                      sx={{ zIndex: "0" }}
                                    >
                                      <PermPhoneMsgIcon color="primary" />
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      badgeContent={
                                        dashboardcountagent
                                          ? dashboardcountagent.abadonedcount
                                          : null
                                      }
                                      color="warning"
                                      sx={{ zIndex: "0" }}
                                    >
                                      <OutboundIcon color="primary" />
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      badgeContent={
                                        dashboardcountagent
                                          ? dashboardcountagent.TotalTransferedOut
                                          : null
                                      }
                                      color="warning"
                                      sx={{ zIndex: "0" }}
                                    >
                                      <SyncAltIcon color="primary" />
                                    </Badge>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {spinner ? (
          <div className="body2">
            <div className="loader">
              <img src={spinnerimg} className="logo2" />
              <span className="spinnerspan"></span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setchatdata,
  setchatid,
  setsidebarVal,
  setChatRefresh,
  endInteraction,
  setShowingStatus,
})(Dashboard);
